<i18n>
{
"en": {
  "GUARDIANS": "Guardians",
  "MANAGEGUARDIAN": "Manage Guardian",
  "CHOOSEFILTERBY": "Choose Filter By",
  "NAME": "Name",
  "RELATION": "Relation",
  "FATHER": "Father",
  "MOTHER": "Mother",
  "GUARDIAN": "Guardian",
  "PERSONID": "Person ID",
  "FIRSTNAME": "First Name",
  "FATHERNAME": "Father Name",
  "LASTNAME": "Last Name",
  "STUDENTSRELATIONSHIP": "Students Relationship",
  "LOADING": "Loading...",
  "UPLOADIMAGE": "Upload Image",
  "SAVEIMAGE": "Save Image",
  "FIRSTNAME(ARABIC)": "First Name (Arabic)",
  "FATHERNAME(ARABIC)": "Father Name (Arabic)", 
  "LASTNAME(ARABIC)": "Last Name (Arabic)",
  "IDNUMBER": "Id Number",
  "IDEXPIRATIONDATE": "ID Expiration Date",
  "PICKADATE": "Pick a date",
  "NATIONALITY": "Nationality",
  "PLEASESELECTNATIONALITY": "Please Select Nationality",
  "MOBILEPHONE": "Mobile No",
  "CONTACTINFO": "Contact Info",
  "EMAILADDRESS": "Email Address",
  "LANDLINEPHONE": "Landline Phone",
  "SEARCHSTUDENTNAME": "Search Student Name",
  "MAKESUREYOUSELECTEDRELATION": "Make sure you selected relation!",
  "PRIMARYCONTACT": "Primary Contact",
  "PRIMARY": "Primary",
  "NOT": "Not",
  "MESSAGES": "Messages",
  "ERROR": "Error",
  "CLOSE": "Close",
  "STUDENT": "Student",
  "ALREADYINTHELIST": "is already in the list",
  "AVATARPICTUREMUSTBEJPGFORMAT": "Avatar picture must be JPG format!",
  "AVATARPICTURESIZECANNOTEXCEED": "Avatar picture size can not exceed 2MB!",
  "ISREQUIRED": "is required.",
  "ISNOTAVALIDFORMAT": "is not a valid format. Only letters, spaces and dashes are allowed.",
  "ISNOTAVALIDARABICFORMAT": "is not a valid arabic format.",
  "ALREADYEXISTED": "already existed.",  
  "MUSTBEATLEASTCHARACTERSINLENGTH": "must be at least {len} characters in length.",
  "CANNOTEXCEEDCHARACTERSINLENGTH": "cannot exceed {len} characters in length.",  
  "ISREQUIREDTOADDSTUDENT": "is required to add at least 1 student.",
  "INVALIDPHONENO": "is invalid phone number.",
  "MUSTCONTAINAVALIDEMAILADDRESS": "must contain a valid email address.",
  "MOBILENO": "Mobile No" 
},
"ar": {
 "GUARDIANS": "ولي الامر",
  "MANAGEGUARDIAN": "ادارة أولياء الامور",
  "CHOOSEFILTERBY": "اختر الفلتر المطلوب",
  "NAME": "الاسم",
  "RELATION": "الصلة",
  "FATHER": "الاب",
  "MOTHER": "الام",
  "GUARDIAN": "ولي الامر",
  "PERSONID": "الرقم الشخصي",
  "FIRSTNAME": "الاسم الاول",
  "FATHERNAME": "اسم الاب",
  "LASTNAME": "الاسم العائلي",
  "STUDENTSRELATIONSHIP": "صلة القرابة للطالب",
  "LOADING": "جار التحميل...",
  "UPLOADIMAGE": "تحميل الصور",
  "SAVEIMAGE": "احفظ الصورة",
  "FIRSTNAME(ARABIC)": "الاسم الأول (عربي) ",
  "FATHERNAME(ARABIC)": "اسم الأب (عربي) ",
  "LASTNAME(ARABIC)": " الاسم العائلي (عربي) ",
  "IDNUMBER":"رقم الهوية",
  "IDEXPIRATIONDATE": "انتهاء صلاحية الهوية",
  "PICKADATE":"اختر تاريخا",
  "NATIONALITY": "الجنسية",
  "PLEASESELECTNATIONALITY": "يرجى تحديد الجنسية",
  "MOBILEPHONE": "الهاتف المحمول",
  "CONTACTINFO": "معلومات الاتصال",
  "EMAILADDRESS": "عنوان البريد الإلكتروني",
  "LANDLINEPHONE": "الهاتف الثابت",
  "SEARCHSTUDENTNAME": "ابحث عن إسم الطالب",
  "MAKESUREYOUSELECTEDRELATION": "تأكد من أنك اخترت الصلة",
  "PRIMARYCONTACT": " المسؤول الرئيسي",
  "PRIMARY": "الأساسي",
  "NOT": "غير",
  "MESSAGES": "رسائل",
  "ERROR": "خطأ",
  "CLOSE": "أغلق",
  "STUDENT": "طالب",
  "ALREADYINTHELIST": "بالفعل في القائمة",
  "AVATARPICTUREMUSTBEJPGFORMAT": " JPG يجب أن تكون الصورة الرمزية على شكل ",
  "AVATARPICTURESIZECANNOTEXCEED": "2M حجم الصورة الرمزية لا يمكن أن يتجاوز",
  "ISNOTAVALIDFORMAT": ".ليس شكل صحيح. فقط خطابات، ويسمح للمسافات وشرطات",
  "ISNOTAVALIDARABICFORMAT": ".ليست صيغة عربية صحيحة"  ,  
  "ALREADYEXISTED": ".موجودة بالفعل",  
  "ISREQUIRED": ".مطلوب",
  "MUSTBEATLEASTCHARACTERSINLENGTH": ".يجب أن تكون على الأقل {len} حرفا",
  "CANNOTEXCEEDCHARACTERSINLENGTH": ".لا يمكن أن يتجاوز {len} حرفا",  
  "ISREQUIREDTOADDSTUDENT": ".مطلوب إضافة طالب واحد على الأقل",
  "INVALIDPHONENO": ".رقم هاتف غير صالح",
  "MUSTCONTAINAVALIDEMAILADDRESS": ".يجب أن يحتوي على عنوان بريد إلكتروني صالح",
  "MOBILENO": "رقم المحمول"
}
}
</i18n>
<template>
  <div class="form"   v-loading="loading" :element-loading-text="$t('LOADING')">
    <el-card  class="card-border" ref="card" :body-style="{ padding: 0 }">
    <wi-save slot="header" :form="['mainForm', 'contactForm', 'relationForm']" :title="$t('MANAGEGUARDIAN')" :data="{person: this.guardian, students: this.students, contact: this.contact}"></wi-save>
    <el-row>
      <el-col :span="10">

        <el-tabs class="formTab" type="border-card" v-bind:style="{ height: cardHeight + 'px' }">
        <VuePerfectScrollbar  ref="Scrollbar" class="scrollbar"   v-bind:style="{ height: cardHeight + 'px' }">
          <el-form  ref="mainForm" :model="guardian" label-width="120px" label-position="top">

            <el-row :gutter="20" >
              <el-col :span="12">
        
                <wi-upload :person="guardian"></wi-upload>   
 
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('RELATION')" prop="Relation" :rules="{required:true, message:$t('ISREQUIRED'), trigger: 'change'}">
                  <el-radio-group  size="small"  v-model="guardian.Relation">
                    <el-radio-button label="Father">{{$t('FATHER')}}</el-radio-button>
                    <el-radio-button label="Mother">{{$t('MOTHER')}}</el-radio-button>
                    <el-radio-button label="Guardian">{{$t('GUARDIAN')}}</el-radio-button>
               </el-radio-group>                  
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('FIRSTNAME')" prop="FirstName_EN" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="guardian.FirstName_EN"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('FIRSTNAME(ARABIC)')" prop="FirstName_AR" :rules="[{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="guardian.FirstName_AR"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('FATHERNAME')" prop="MiddleName" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="guardian.MiddleName"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('FATHERNAME(ARABIC)')" prop="MiddleName_AR" :rules="[{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="guardian.MiddleName_AR"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('LASTNAME')" prop="LastName_EN" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="guardian.LastName_EN"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('LASTNAME(ARABIC)')" prop="LastName_AR" :rules="[{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="guardian.LastName_AR"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('IDNUMBER')" prop="ExternalPersonID" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{validate: true, message: $t('IDNUMBER') + ' ' + $t('ALREADYEXISTED')},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'}]">
                  <el-input  v-model="guardian.ExternalPersonID"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('IDEXPIRATIONDATE')" prop="IDExpiration" :rules="{type: 'date', required: true, message:$t('ISREQUIRED'), trigger:'blur,change'}">
                  <el-date-picker type="date" :placeholder="$t('PICKADATE')" :picker-options="pickerOption" :format="date_format" v-model="guardian.IDExpiration"   style="width: 100%"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">

              <el-col :span="12">
                <el-form-item :label="$t('NATIONALITY')" prop="Nationality" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'change'}">
                  <el-select   v-model="guardian.Nationality" :placeholder="$t('PLEASESELECTNATIONALITY')" filterable>
                    <el-option :key="key" v-for="(value, key) in $countries" :label="value" :value="key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>


            </el-row>


          </el-form>
            </VuePerfectScrollbar>
        </el-tabs>
      
      </el-col>
      <el-col :span="14">
        <el-tabs type="border-card" class="formTab" v-bind:style="{ height: cardHeight + 'px' }">
          <el-tab-pane :label="$t('CONTACTINFO')">
            <el-form ref="contactForm" :model="contact" label-width="120px" label-position="top"  style="padding:20px; padding-bottom:0">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item :label="$t('MOBILEPHONE')" prop="MobilePhone" :rules="[{required: true, message:$t('ISREQUIRED'), trigger:'blur'},{validator:phoneValidation, message:$t('INVALIDPHONENO'), trigger:'blur' }]">
                    <el-input v-model="contact.MobilePhone"></el-input>
                  </el-form-item>
                </el-col>


                <el-col :span="8">
                  <el-form-item :label="$t('EMAILADDRESS')" prop="EMail" :rules="[{required: true, message:$t('ISREQUIRED'), trigger:'blur'},{min:6, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 6}), trigger:'blur'},{type:'email', message:$t('MUSTCONTAINAVALIDEMAILADDRESS'), trigger:'blur'},{max:50, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 50}), trigger:'blur'},{validate: true, message: $t('EMAILADDRESS') + ' ' + $t('ALREADYEXISTED')}]">
                    <el-input  v-model="contact.EMail"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item :label="$t('LANDLINEPHONE')" prop="LandlinePhone" :rules="{validator:phoneValidation, message:$t('INVALIDPHONENO'), trigger:'blur' }">
                    <el-input v-model="contact.LandlinePhone"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :label="$t('STUDENTSRELATIONSHIP')">
            <el-form ref="relationForm" :labelSuffix="$t('GUARDIAN')" label-width="120px" label-position="top"  style="padding:20px; padding-bottom:0">
              <el-form-item prop="student" :rules="[{validator:hasRelation, message:$t('ISREQUIREDTOADDSTUDENT'), trigger:'blur'}]">              
                <el-autocomplete
                  v-model="student"
                  :fetch-suggestions="querySearch"
                  :placeholder="$t('SEARCHSTUDENTNAME')"
                  :disabled="!guardian.Relation"
                  @select="addStudent"
                  icon="search"
                ></el-autocomplete>
              </el-form-item>
              <span v-if="!guardian.Relation">{{$t('MAKESUREYOUSELECTEDRELATION')}}</span>
            </el-form>
            <el-row class="tab-table-margin" style="margin-top:20px">
            <el-table
            :data="students"
            highlight-current-row
            :height="cardHeight-118"
            stripe
            style="width: 100%">
            <el-table-column
              :label="$t('NAME')"
              align="left"
            >
              <template slot-scope="scope">
                <img :src="getAsset(scope.row.ImagePath, 'student')" alt="" class="img-circle" style="width: 50px; float: left;">
                {{_FullName({NameEN: scope.row.FullName_EN, NameAR: scope.row.FullName_AR})}}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('PRIMARYCONTACT')"
              align="center">
              <template slot-scope="scope">
              <span v-text="scope.row.IsMain===null ? $t('NOT') : ''"></span> {{$t('PRIMARY')}}
              </template>
            </el-table-column>

            <el-table-column
              align="right">
              <template slot-scope="scope">
                <i v-show="guardian.PersonID!==undefined" @click="scope.row.deleted=!scope.row.deleted" class="fa fa-2x" v-bind:class="scope.row.deleted ? 'fa-undo' : 'fa-remove'"></i>
              </template>
            </el-table-column>
          </el-table>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="Messages" v-if="false">{{$t('MESSAGES')}}</el-tab-pane>

        </el-tabs>
      </el-col>
    </el-row>
    </el-card>
    <el-dialog :title="$t('ERROR')" v-model="error" size="tiny">
      <div class="el-alert el-alert--error">
        <i class="el-alert__icon el-icon-circle-cross is-big"></i>
        <div class="el-alert__content">
          <span class="el-alert__title is-bold" v-for="(messageError, key) in message" v-html="printError(messageError, key)"></span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="error = false">{{$t('CLOSE')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import axios from 'axios'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import WiUpload from '@/components/dialogs/Upload'
  import WiSave from '@/components/dialogs/Save'
  import _ from 'lodash'
  export default {
    components: {VuePerfectScrollbar, 'wi-upload': WiUpload, 'wi-save': WiSave},
    data () {
      return {
        guardian: {Relation: null, IDExpiration: null, Nationality: null, ImagePath: null},
        contact: {},
        school: {},
        student: null,
        students: [],
        activeIndex: '',
        handleSelect: '',
        dialogVisible: false,
        dialogImageUrl: '',
        cardHeight: 0,
        loading: false,
        message: null,
        existedKey: null,
        error: false,
        date_format: 'dd/MM/yyyy',
        pickerOption: {
          disabledDate (time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        },
        autoSource: null
      }
    },
    watch: {
      students: {
        handler (data) {
          this.$nextTick(function () { this.$refs.relationForm.validateField('student') })
        },
        deep: true
      }
    },
    mounted () {
      this.switchLanguage()
      this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53
      this.getGuardian()
    },
    methods: {
      printError (message, key) {
        if (key === 'exception') return message
        let error = message.split(' ')
        if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], {len: error[2]}) + '</br>'
        return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>'
      },
      phoneValidation (rule, value, callback) {
        let regex = /^\+?[\d-]+$/
        if (value && !regex.test(value)) callback(this.$t('INVALIDPHONENO'))
        callback()
      },
      hasRelation (rule, value, callback) {
        if (this.students.length > 0) {
          let deleted = _.filter(this.students, 'deleted')
          if (this.students.length !== deleted.length) return callback()
        }
        callback(this.$t('ISREQUIREDTOADDSTUDENT'))
      },
      imageUploaded (res) {
        if (res.file_name !== undefined) this.guardian.ImagePath = res.file_name
      },
      getGuardian () {
        let self = this
        if (this.$route.params.id === 'create') return
        this.loading = true
        this.$http.get('/guardian/' + this.$route.params.id).then(function (response) {
          self.guardian = response.data.person
          self.guardian.IDExpiration = self.dateFormat(self.guardian.IDExpiration)
          self.contact = response.data.contact
          self.students = response.data.students
          self.loading = false
        }).catch(function (response) {})
      },
      onSubmit () {
        console.log('submit!')
      },
      handleRemove (file, fileList) {
        console.log(file, fileList)
      },
      handlePictureCardPreview (file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      addStudent (data) {
        let student = data.student
        if (this.students !== undefined) {
          for (let i = 0; i < this.students.length; i++) {
            if (this.students[i].StudentID === student.StudentID) {
              this.error = true
              this.status = 'Error'
            }
          }
          if (this.error) {
            this.message = {exception: this.$t('STUDENT') + ': ' + (student.FirstName_EN + ' ' + student.FirstName_EN) + ' ' + this.$t('ALREADYINTHELIST')}
            return
          }
        }
        if (student.IsMain === null) {
          student.IsMain = 1
        } else {
          student.IsMain = null
        }
        this.student = null
        this.students.push(student)
      },
      querySearch (queryString, cb) {
        let self = this
        if (self.student === null) return
        if (self.autoSource) self.autoSource.cancel()
        let result = self.findStudent(queryString)
        result.then(function (response) {
          self.autoSource = null
          cb(!response.data ? [] : response.data)
        }).catch(function () {
        })
      },
      findStudent (queryString) {
        this.autoSource = axios.CancelToken.source()
        return this.$http.get('/student/find?term=' + queryString + '&lang=' + localStorage.getItem('lang') + '&id=' + this.guardian.PersonID + '&from=route', {cancelToken: this.autoSource.token})
      },
      handleAvatarSuccess (res, file) {
        this.student.ImagePath = URL.createObjectURL(file.raw)
      },
      beforeAvatarUpload (file) {
        const isJPG = file.type === 'image/jpeg'
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isJPG) {
          this.$message.error(this.$t('AVATARPICTUREMUSTBEJPGFORMAT'))
        }
        if (!isLt2M) {
          this.$message.error(this.$t('AVATARPICTURESIZECANNOTEXCEED'))
        }
        return isJPG && isLt2M
      }
    }
  }
</script>

<style>

</style>




// WEBPACK FOOTER //
// GuardianManage.vue?49b4eee0